<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="estructura-documentos" titulo="Documentos / Catálogo"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;">

                <!--Tabla -->
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th><abbr>ID</abbr></th>
                            <th>Tipo Documento</th>
                            <th>Descripcion</th>
                            <th>Nivel Educativo</th>
                            <th>Categoria</th>
                            <th>Activo</th>
                            <th>Ultima actualización</th>
                            <th width="1%" class="no_pdf">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <th style="vertical-align: middle;">
                                {{ item.id }}
                            </th>
                            
                            <td style="vertical-align: middle;" [class.has-text-danger]="!item.tipo_documento">
                                {{ item.tipo_documento || 'No configurado !' }}
                            </td>
                            <td style="vertical-align: middle;">
                                {{ item.nombre }} 
                            </td>
                            <td style="vertical-align: middle;" [class.has-text-danger]="!item.niveles_educativos">
                                <span *ngIf="item.niveles_educativos" class="tag is-gray has-text-dark">
                                    {{item.niveles_educativos?.idNivelEstudios || '' }}
                                </span>
                                {{ item.niveles_educativos?.nombre || 'No configurado !' }}
                            </td>

                            <td style="vertical-align: middle;">
                                {{ item.tipo_rvoe == 'ESTATAL' ? '* ESTATAL': '> FEDERAL' }} 
                            </td>

                            <td style="vertical-align: middle;">
                                <span class="tag"
                                    [ngClass]="item.activo == 1 ? 'is-success' : 'is-danger'">
                                    {{ item.activo == 1 ? 'SI' : 'NO' }}
                                </span>
                            </td>
                            

                            <td style="vertical-align: middle;">{{ item.updated_at }} </td>
                            <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="4" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="./assets/128x128.png" alt="Image">
                            </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong style="font-size:12pt">{{ i + 1 }}</strong>Nombre: {{ item.nombre }}
                                        <strong style="font-size:12pt">Activo: {{item.activo}}</strong>
                                        <br>
                                        <strong style="color:darkblue"   class="tag is-light is-medium"> Última actualización: {{item.updated_at}}</strong>

                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
              </div>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>
